<template>
    <div class="main-content">
        <the-header :title="t('Login as')"/>
        <nav-body :links="nav">
          <div>Temporarily disabled</div>
<!--            <titan-form :schema="schema" v-on:saveData="saveData()" :model="dataItem"/>-->
        </nav-body>
    </div>
</template>
<script>
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import NavBody from '../../../../admin/Layout/NavBody'
    import StaticText from '../../../../admin/Pages/StaticText/StaticText';
    import {admin} from '../Admin'
    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    export default {
        mixins: [admin],
        components: {
            StaticText,
            TheHeader,
            NavBody,
            TitanForm
        },
        methods: {
            saveData() {
                this.$store.dispatch('account/loginAs', this.dataItem).then(res => {
                    window.location.reload();
                });
            }
        },
        data() {
            return {
                dataItem: {
                    user: '',
                    password: '',
                },
                schema: [
                    {
                        name: this.t('Login as'),
                        type: 'main',
                        fields: [
                            {
                                type: 'titanSelect',
                                label: this.t('user'),
                                codeBook: 'user',
                                valueLabel: 'fullName',
                                constant: true,
                                model: 'user',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('Password'),
                                model: 'password',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/private/admin/loginAs/LoginAs.vue